import {Inject, injectable} from 'inversify-props';
import {TypedJSON} from 'typedjson';

import {LoraForwarder} from '@/model/lora/LoraForwarder';
import {LoraForwarderState} from '@/model/lora/LoraForwarderState';

import {ILoraForwardersService} from '@/services/lora/ILoraForwarders.service';
import {IApiService} from '@/services/IApi.service';

@injectable()
export class LoraForwardersService implements ILoraForwardersService {

  @Inject(Symbol.for('IApiService'))
  private apiService!: IApiService;

  private path: string = '/lora/forwarder';

  private serializer = new TypedJSON(LoraForwarder);

  public async getAvailable(): Promise<LoraForwarder[]> {
    return this.apiService.get(`${this.path}/available`);
  }

  public async getActive(): Promise<LoraForwarder | null> {
    const forwarderData = await this.apiService.get(`${this.path}/active`);

    if (forwarderData) {
      return this.serializer.parse(forwarderData)!;
    } else {
      return null;
    }
  }

  public async setActive(forwarder: string): Promise<any> {

    const config = {
      timeout: 30000,
    };

    return this.apiService.post(`${this.path}/active`, {
      id: forwarder,
    }, config);
  }

  public async getActiveForwarderState(): Promise<LoraForwarderState> {
    return await this.apiService.get(`${this.path}/state`);
  }
}
